module.exports = __webpack_public_path__ + "img/chess.7d3af3e3.jpeg";